import BaseApi from './BaseApi'

export default class Feedback extends BaseApi {
  send(feedback) {
    return this.http.post('/feedback', feedback)
  }
}
